module.exports = __webpack_public_path__ + "img/important-project-right.b16f343a.png";